import * as React from "react"
import { Link } from "react-router-dom"
import { Price, Badge } from "components"
import { useInView } from "react-intersection-observer"
import { percentage, toPersianDigits } from "utils"
import "./productItem.scss"

interface ProductItem {
	id: number
	image: string
	item_name: string
	item_id: number
	group_name: string
	url: string
	price: number
	old_price: number
	special?: boolean
}

const ProductItem: React.FC<ProductItem & { className?: string }> = ({
	className = "",
	image,
	item_name,
	url,
	price,
	old_price,
	id,
	special = false,
}) => {
	const [ref, inView] = useInView({ triggerOnce: true, rootMargin: "100px" })
	const off = percentage(price, old_price)
	return (
		<Link
			className={className}
			draggable={false}
			to={`/product/NAP-${id}/${url}`}
		>
			<div
				ref={ref}
				className="product__item d-flex flex-column bd-highlight justify-content-center align-items-center text-center pb-3"
			>
				<img
					src={inView ? image : ""}
					draggable={false}
					className={inView ? "product__item__img" : ""}
					alt={item_name}
				/>
				<p>{item_name}</p>
				<Price symbool discount={old_price}>
					{price}
				</Price>
				{(special || off >= 30) && (
					<Badge
						color="accent"
						placement="top-right"
						className="px-2"
					>
						فروش ویژه
					</Badge>
				)}
				<Badge color="jade" placement="top-left" className="px-2">
					{toPersianDigits(percentage(price, old_price))}%
				</Badge>
			</div>
		</Link>
	)
}

export default ProductItem
